module.exports = __webpack_public_path__ + "img/main_desktop_landing.6fbafc0d.jpeg";